import DownloadStatusListDialog from '../../study-material/DownloadStatusListDialog'
import { Box, Button, Dialog, DialogContent, Typography, useTheme } from '@mui/material'
import { useLayoutContext } from '../../../../shared/contexts/layout.context'
import sessionEndedImg from '../../../../shared/assets/waiting.svg'
import aliveLogoImg from '../../../../shared/assets/alivelogo.png'
import { useAuthStore } from '../../../store/auth.store'
import { Outlet } from 'react-router-dom'
import { LoginOutlined } from '@mui/icons-material'
import SideDrawer from './PresenterSideDrawer'
import { useCallback, useEffect, useRef } from 'react'
import Navbar from './PresenterNavbar'
import React from 'react'
import { observer } from 'mobx-react'
import ResourceUploadStatusDialog from '../../live-session/ResourceUploadStatusDialog'
import api from '../../../service/api'
import { ERPLoginPageURL } from '../../../../shared/utils/constants.jsx'



const getModuleByPathname = ( pathname ) => {
    if ( [/^(\/faculty\/subject\/\d+\/materials)\/?$/, /^(\/faculty\/material)\/?$/, /^(\/faculty\/material\/\d+)\/?$/, /^(\/faculty\/material\/add)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "materials"
    else if ( [/^(\/faculty\/subject\/\d+\/assignments)\/?$/, /^(\/faculty\/assignment)\/?$/, /^(\/faculty\/assignment)\/\d+\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "assignment"
    else if ( [/^(\/faculty\/exams)\/?$/, /^(\/faculty\/addexam)\/?$/, /^(\/faculty\/exams\/\d+)\/?$/, /^(\/faculty\/exams\/\d+\/questions)\/?$/, /^(\/faculty\/exams\/\d+\/addquestions)\/?$/, /^(\/faculty\/participations)\/?$/, /^(\/faculty\/exams\/\d+\/participation)\/?$/, /^(\/faculty\/exams\/\d+\/evaluate\/\d+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "exam"
    else if ( [/^(\/faculty\/subject\/\d+\/discussion)\/?$/, /^(\/faculty\/subject\/\d+\/exams)\/?$/, /^(\/faculty\/discussions)\/?$/, /^(\/faculty\/discussions\/\w+)\/?$/, /^(\/faculty\/my-discussions\/\w+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "discussion"
    else if ( [/^(\/faculty\/questionbank)\/?$/, /^(\/faculty\/questionbank)\/\d+\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "question_bank"
    else if ( [/^(\/faculty\/proctoring\/proctees)\/?$/, /^(\/faculty\/academics\/audit)\/?$/, /^(\/faculty\/proctoring\/proctee\/\w{12}\/?)$/].some( regexp => pathname.match( regexp ) ) )
        return "academics"
    else if ( [/^(\/faculty\/subject\/\d+\/class-sessions)\/?$/, /^(\/faculty\/subject\/\d+\/class-sessions\/\d+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "class_session"
    else if ( [/^(\/faculty\/subject\/\d+\/aimentor)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "aimentor"
    else if ( [/^(\/faculty\/stream)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "online_class"
    else if ( [/^(\/faculty\/subjects)\/?$/, /^(\/faculty\/subject\/\d+)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "subjects"
    else if ( [/^(\/faculty\/quizzes)\/?$/, /^(\/faculty\/quizzes)\/\d+\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "quiz"
    else if ( [/^(\/faculty\/home)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "home"
    else if ( [/^(\/faculty\/faq)\/?$/].some( regexp => pathname.match( regexp ) ) )
        return "faq"
    else return null
}

const PresenterLayout = observer( ( { navHeadText } ) => {

    const { setMenuState, navHeight, minSidebarCollapseWidth, active } = useLayoutContext()

    const handleResizeOrLoad = useCallback( () => {
        if ( window.innerWidth < minSidebarCollapseWidth )
            setMenuState( false )
        else {
            setMenuState( true )
        }
    }, [minSidebarCollapseWidth, setMenuState] )

    const AuthStore = useAuthStore()
    const { palette, theme } = useTheme()

    const previousModule = useRef( null )
    const previousModuleChangedTime = useRef( Date.now() )
    const activities = useRef( {} )

    const navigateToSigninPage = () => {
        const redirectValue = encodeURIComponent( `${window.location.pathname}${window.location.search}` )
        window.location.href = `${ERPLoginPageURL}?redirect=${redirectValue}`
    }

    const registerActivities = useCallback( async ( calculateAgain = false ) => {
        try {
            const module = getModuleByPathname( active )
            let activitiesToSend = activities.current

            if ( module && calculateAgain ) {
                const now = Date.now()
                const timeSpentOnLastModule = Math.round( ( now - previousModuleChangedTime.current ) / 1000 )
                const previousModuleValue = module

                const newValues = { ...activitiesToSend }
                if ( !["subjects", "home", "faq"].includes( previousModule.current ) ) {
                    if ( !newValues[previousModuleValue] )
                        newValues[previousModuleValue] = timeSpentOnLastModule
                    else
                        newValues[previousModuleValue] = newValues[previousModuleValue] + timeSpentOnLastModule
                }
                newValues.total = newValues.total ? newValues.total + timeSpentOnLastModule : timeSpentOnLastModule
                activitiesToSend = newValues

                previousModule.current = module
                previousModuleChangedTime.current = now
            }
            await api.registerSessionTrackDetails( { activities_details: activitiesToSend, updateValue: "timeSpent" } )
            activities.current = {}
        } catch ( err ) {
            console.log( err )
        } finally {
        }
    }, [active] )

    useEffect( () => {
        if ( active !== "/" ) {
            const module = getModuleByPathname( active )
            console.log( `Moved to ${module} from ${previousModule.current}` )

            if ( module && module !== previousModule.current ) {
                const now = Date.now()
                const timeSpentOnLastModule = Math.round( ( now - previousModuleChangedTime.current ) / 1000 )
                const previousModuleValue = previousModule.current

                console.log( `You spent ${timeSpentOnLastModule} seconds on ${previousModule.current}...` )

                if ( previousModule.current ) {
                    const newValues = { ...activities.current }
                    if ( !["subjects", "home", "faq"].includes( previousModule.current ) ) {
                        if ( !newValues[previousModuleValue] )
                            newValues[previousModuleValue] = timeSpentOnLastModule
                        else
                            newValues[previousModuleValue] = newValues[previousModuleValue] + timeSpentOnLastModule
                    }
                    newValues.total = newValues.total ? newValues.total + timeSpentOnLastModule : timeSpentOnLastModule
                    activities.current = newValues
                }

                previousModule.current = module
                previousModuleChangedTime.current = now
            }
        }
    }, [active] )

    useEffect( () => {

        window.addEventListener( 'resize', handleResizeOrLoad )
        window.addEventListener( 'load', handleResizeOrLoad )
        return () => {
            window.removeEventListener( 'resize', handleResizeOrLoad )
            window.removeEventListener( 'load', handleResizeOrLoad )
        }
    }, [handleResizeOrLoad] )


    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: { sm: "row", xs: "column-reverse" },
                height: "100%",
                overflow: "auto",
                background: palette.layoutBackground
            }}>
            <SideDrawer closeSideMenu={() => setMenuState( false )} />
            <Box
                sx={{
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    minWidth: "0",
                    position: "relative",
                    overflow: "auto"
                }}>
                <Navbar onLogout={registerActivities} navHeadText={navHeadText} closeSideMenu={() => setMenuState( false )} openSideMenu={() => setMenuState( true )} />
                {AuthStore.getErpSessionState !== "ended" &&
                    <Box
                        id="page-content"
                        className={theme}
                        sx={{
                            bgcolor: palette.background.default,
                            overflow: "auto",
                            borderRadius: { sm: "10px 0 0 0", xs: "0" },
                            flexGrow: 1,
                            display: "flex",
                            minWidth: "0",
                            position: "relative"
                        }}>
                        {/* <Box position="absolute" sx={{ zIndex: 100, inset: 0, opacity: "0.1", pointerEvents: "none" }} height="100%" display="flex" alignItems="center" justifyContent="center"  >
                            <Box component="img" loading='lazy' sx={{ opacity: "0.4" }} width="30%" src={aliveLogoImg} />
                        </Box> */}
                        <Outlet />
                    </Box>}
            </Box>
            <Dialog open={AuthStore.getErpSessionState === "ended"}>
                <DialogContent >
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "20px",
                            flexDirection: "column"
                        }}>
                        <img width="200px" src={sessionEndedImg} alt="Session ended!" />
                        <Typography variant='subtitle2' sx={{
                            textAlign: "center"
                        }}>Your ERP session seems to have ended! did you log in using ERP credentials somewhere else? please login again.</Typography>
                        <Button onClick={navigateToSigninPage} startIcon={<LoginOutlined fontSize='small' />} variant='outlined' sx={{ textTransform: "capitalize" }}>Sign In</Button>
                    </Box>
                </DialogContent>
            </Dialog>
            <DownloadStatusListDialog />
            <ResourceUploadStatusDialog />
        </Box>
    );
} )

export default PresenterLayout
